/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment,
@typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call*/
import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    Renderer2,
} from '@angular/core';
import { TreeViewDropEvent, TreeViewFlatNode } from '@app/shared/models/tree-view.model';
import { TreeViewDragRelation, TreeViewDragStatus } from '@app/shared/constants/tree-view';

@Directive({
    selector: '[appTreeViewDrag]',
    standalone: false,
})
export class TreeViewDragDirective<T> implements OnInit {
    @Input() treeViewDragNode: TreeViewFlatNode<T>;
    @Input() treeViewDragStatus: TreeViewDragStatus;

    @Output() treeViewDrop = new EventEmitter<TreeViewDropEvent<T>>();

    private defaultStyles = {
        'background-color': '#fff',
        'border-bottom': 'none',
    };

    private childStyles = {
        'background-color': '#efefef',
        'border-bottom': 'none',
    };

    private siblingStyles = {
        'background-color': '#fff',
        'border-bottom': `solid 1px #efefef`,
    };

    private relation: TreeViewDragRelation;

    constructor(private renderer: Renderer2, private element: ElementRef) {}

    ngOnInit(): void {
        const paddingLeft = this.element.nativeElement.style['padding-left'];
        this.renderer.setStyle(this.element.nativeElement, 'padding-left', '0px');
        this.renderer.setStyle(this.element.nativeElement, 'margin-left', paddingLeft);
    }

    @HostListener('mouseover', ['$event']) public onNodeEnter(event: MouseEvent) {
        if (this.treeViewDragStatus === TreeViewDragStatus.DRAGGING) {
            const elementRect = this.element.nativeElement.getBoundingClientRect();
            const relativePosition = event.clientY - elementRect.y;
            const percentage = (relativePosition / elementRect.height) * 100;
            this.relation =
                percentage <= 70 ? TreeViewDragRelation.CHILD : TreeViewDragRelation.SIBLING;

            if (this.relation === TreeViewDragRelation.CHILD) {
                this.treeViewDragNode.icon = 'add_circle';
            } else {
                this.treeViewDragNode.icon = '';
            }

            this.applyStyles(this.relation);
        } else {
            this.treeViewDragNode.icon = 'open_with';
        }
    }

    @HostListener('mouseout', ['$event']) public onNodeOut() {
        if (this.treeViewDragStatus === TreeViewDragStatus.DRAGGING) {
            this.applyStyles();
        }

        this.treeViewDragNode.icon = '';
    }

    @HostListener('mouseup', ['$event']) public onMouseUp() {
        if (this.treeViewDragStatus === TreeViewDragStatus.STAND_BY) {
            return;
        }

        this.applyStyles();
        this.treeViewDrop.emit({
            node: this.treeViewDragNode,
            relation: this.relation,
        });
    }

    private applyStyles(relation?: TreeViewDragRelation) {
        let styles = this.defaultStyles;

        if (relation) {
            styles =
                relation === TreeViewDragRelation.CHILD ? this.childStyles : this.siblingStyles;
        }

        Object.keys(styles).forEach((newStyle) => {
            this.renderer.setStyle(this.element.nativeElement, `${newStyle}`, styles[newStyle]);
        });
    }
}
